var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", [_vm._v("Verified by GS1")]),
      _vm._v(" "),
      _c("CompanySearchForm", {
        staticStyle: { "margin-bottom": "25px" },
        on: { submit: _vm.submitCompanySearch },
        model: {
          value: _vm.companySearch,
          callback: function($$v) {
            _vm.companySearch = $$v
          },
          expression: "companySearch"
        }
      }),
      _vm._v(" "),
      _vm.loading
        ? _c("gs1-alert-loading")
        : _vm.saveGet(_vm.results.licences, []).length > 0
        ? _c(
            "div",
            {
              staticClass: "content-module-wrapper",
              staticStyle: { "border-top-color": "transparent" }
            },
            [
              _c("div", { staticClass: "content-module" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "table",
                      { staticClass: "table", staticStyle: { width: "100%" } },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v(_vm._s(_vm.$t("license_key")))]),
                            _vm._v(" "),
                            _c("th", [_vm._v(_vm._s(_vm.$t("company_name")))]),
                            _vm._v(" "),
                            _c("th", [_vm._v(_vm._s(_vm.$t("licensee_gln")))]),
                            _vm._v(" "),
                            _c("th", [_vm._v(_vm._s(_vm.$t("city")))]),
                            _vm._v(" "),
                            _c("th", [_vm._v(_vm._s(_vm.$t("country")))]),
                            _vm._v(" "),
                            _c("th", [_vm._v(_vm._s(_vm.$t("options")))])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.sortedLicences, function(company) {
                            return _c("tr", { key: company.licenceKey }, [
                              company.licenceType === "GCP"
                                ? _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(company.licenceKey) +
                                        "\n                "
                                    )
                                  ])
                                : _c("td", [_vm._v("-")]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "CompanyModal",
                                    { attrs: { value: company } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(company.licenseeName) +
                                            "\n                    "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isMainTrue(company) &&
                              company.licenceType === "GCP" &&
                              company.licenceKey.length < 12
                                ? _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.saveGet(
                                            company,
                                            "-",
                                            "licenseeGLN"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("td", [_vm._v("-")]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.saveGet(
                                    company,
                                    false,
                                    "address",
                                    "addressLocality",
                                    "value"
                                  )
                                    ? _c(
                                        "MapModal",
                                        {
                                          attrs: {
                                            value: _vm.saveGet(
                                              company,
                                              null,
                                              "address"
                                            ),
                                            company: company.licenseeName
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.saveGet(
                                                  company,
                                                  false,
                                                  "address",
                                                  "addressLocality",
                                                  "value"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _c("span", [_vm._v(" - ")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.saveGet(
                                    company,
                                    "",
                                    "address",
                                    "countryCode"
                                  ).length === 2
                                    ? _c("lang-string", {
                                        attrs: {
                                          lang: _vm.saveGet(
                                            company,
                                            "",
                                            "address",
                                            "countryCode"
                                          )
                                        }
                                      })
                                    : _c("span", [_vm._v("-")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("CompanyModal", {
                                    staticStyle: { display: "inline-block" },
                                    attrs: { value: company }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [
                                      _vm.saveGet(company, false, "address")
                                        ? _c("MapModal", {
                                            attrs: {
                                              value: _vm.saveGet(
                                                company,
                                                null,
                                                "address"
                                              ),
                                              company: company.licenseeName
                                            }
                                          })
                                        : _c("span", {
                                            staticClass: "fa fa-map text-muted"
                                          })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          })
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        : _c("h3", [_vm._v(_vm._s(_vm.$t("not_found")))]),
      _vm._v(" "),
      _vm.saveGet(_vm.results.totalRecords, 0) > 100
        ? _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("more_results", {
                  totalRecords: _vm.saveGet(_vm.results.totalRecords, 0)
                })
              )
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d1c99ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d1c99ad","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/Companies.vue
// module id = null
// module chunks = 